module.exports = __webpack_public_path__ + "static/media/home_logo.953babad.png";